import apiClient from "../../../../http-common"
//--------------------Get All Pass Type list--------------------
export const getAllPassTypeList = async (listObject) => {
    return await apiClient.post(`/master/passType/list`, listObject, {
        // headers:authHeader()
    });
};



// searchString
export const passTypeBySearchString = async (searchString) => {
    return await apiClient.get(`master/passType/${searchString}`, {
        // headers:authHeader()
    });
};



// //Delete Record By ID

export const deletePassTypeById = async (id) => {
    return await apiClient.delete(`master/passType/delete/${id}`, {
        // headers:authHeader()
    });
};

//Save
export const savePassType = async (finalData) => {
    return await apiClient.post(`/master/passType/save`, finalData, {
        // headers:authHeader()
    });
};

//update 
export const updatePassType = async (finalData) => {
    return await apiClient.post(`/master/passType/update`, finalData, {
        // headers:authHeader()
    });
};

// dropdown
export const passTypeDropdown = async () => {
    return await apiClient.get(`/master/passType/dropDown`, {
        // headers:authHeader()
    });
}; 